import { ErrorCode } from 'src/shared/enum/ErrorCode';

const MONTH_MAP: Record<string, number> = {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
};

export const mapMonthName = (month: string): number => {
    const monthMapped = MONTH_MAP[month] as number;

    if (monthMapped === null || monthMapped === undefined) {
        throw new Error(ErrorCode.MONTH_NOT_FOUND);
    }

    return monthMapped as number;
};
